import { useContext } from 'react'

import { statusCodeErrorMessage } from '@/common/app/error'
import { HttpStatusCode } from '@/common/util/status'

import { MessageType } from '@/components/view/molecules/bar/MessageBar'

import { ToastMessageContext } from '@/components/container/utils/message/ToastMessageProvider'

export const useShowSavedToast = ({ editing }: { editing: boolean }) => {
  const { addMessage } = useContext(ToastMessageContext)

  return (name: string) => {
    addMessage({
      text: `${name}を${editing ? '更新' : '登録'}しました。`,
      type: MessageType.SUCCESS
    })
  }
}

export const useShowDeletedToast = () => {
  const { addMessage } = useContext(ToastMessageContext)

  return (name: string) => {
    addMessage({ text: name + 'を削除しました。', type: MessageType.SUCCESS })
  }
}

export const useShowCopiedToast = () => {
  const { addMessage } = useContext(ToastMessageContext)

  return (name: string) => {
    addMessage({ text: name + 'をコピーしました。', type: MessageType.SUCCESS })
  }
}

export const useShowCopyFailedToast = () => {
  const { addMessage } = useContext(ToastMessageContext)

  return (name: string) => {
    addMessage({ text: name + 'のコピーに失敗しました。', type: MessageType.CRITICAL })
  }
}

export const useShowErrorToast = () => {
  const { addMessage } = useContext(ToastMessageContext)

  return async (error: Response) => {
    const json = await error.json()
    addMessage({
      text: json.detail ?? statusCodeErrorMessage(error.status),
      type: MessageType.CRITICAL
    })
  }
}

export const useShowToastIfMutationError = () => {
  const { addMessage } = useContext(ToastMessageContext)

  return async (error: Response) => {
    if (error) {
      const json = await error.json()
      addMessage({
        text:
          json.detail ??
          statusCodeErrorMessage(error.status ?? HttpStatusCode.INTERNAL_SERVER_ERROR),
        type: MessageType.CRITICAL
      })
    }
  }
}
